<template>
  <div v-if="$route.params.floor" class="location px-4 text-center">
    <div v-show="!showFloorsMap" class="floor-room-name">
      <span class="d-none d-md-block">
        {{ $root.allLanguages[$language.current].currentPositionLabel }}
      </span>
      <div class="d-md-flex align-md-center justify-md-center">
        <span class="d-block d-md-inline-block">
          {{translatedFloor}}&nbsp;
          <HandSvg :class="{ 'isBlack': showFloorsMap }" class="hand" />&nbsp;
        </span>
        <span class="d-block d-sm-inline-block text-truncate">{{ translatedRoom }}</span>
      </div>
    </div>
    <div
      v-show="showFloorsMap && !$root.platform.mobile"
      class="pt-2 pt-md-0 text-align-left"
    >
      <transition name="fade">
        <h4 v-if="currentRoomOver !== ''" class="name light floor mb-0">
          {{getTranslatedFloor(currentFloorOver)}}&nbsp;
          <HandSvg :class="{ 'isBlack': showFloorsMap }" class="hand" />
        </h4>
      </transition>
      <transition name="slide-fade-up" mode="out-in">
        <h4 class="ml-1 mb-0" :key="currentRoomOver">
          {{currentRoomOver !== '' ? getTranslateRoom(currentRoomOver) : ''}}
        </h4>
      </transition>
    </div>
  </div>
</template>

<script>
import HandSvg from '@/assets/svg/point.svg'

export default {
  components: { HandSvg },
  methods: {
    getTranslateRoom (roomName) {
      let room = roomName.replace(/-/g, ' ')
      const cutRoomName = roomName.substring(0, roomName.length - 1)
      const splitRoomName = cutRoomName.split('-')[0].toLowerCase()

      if (this.$root.allLanguages[this.$route.params.language][splitRoomName]) {
        room = this.$root.allLanguages[this.$route.params.language][splitRoomName]
      } else {
        for (let i = 0; i < this.$root.floors.length; i++) {
          const floor = this.$root.floors[i]

          for (let n = 0; n < floor.rooms.length; n++) {
            const element = floor.rooms[n].roomName
            if (element._slug.indexOf(cutRoomName) > -1) {
              const ttl = element[this.$route.params.language + 'Title']
              if (ttl && ttl !== '') {
                room = element[this.$route.params.language + 'Title']
              } else if (element.enTitle) {
                room = element.enTitle
              }
            }
          }
        }
      }
      return room
    },
    getTranslatedFloor (infloor) {
      let floor = ''
      for (let i = 0; i < this.$root.floors.length; i++) {
        const element = this.$root.floors[i]
        if (element._slug === infloor) {
          if (element[this.$route.params.language + 'Title']) {
            floor = element[this.$route.params.language + 'Title']
          } else if (element.enTitle) {
            floor = element.enTitle
          }
        }
      }
      return floor
    }
  },
  computed: {
    translatedFloor () {
      return this.getTranslatedFloor(this.$route.params.floor)
    },
    translatedRoom () {
      return this.getTranslateRoom(this.$route.params.roomName)
    }
  },
  props: {
    showFloorsMap: {
      type: Boolean,
      required: true
    },
    currentRoomOver: {
      type: String,
      required: true
    },
    currentFloorOver: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.location {
  position: relative;
}

.light {
  font-size: 16px;
  font-weight: 600 !important;
  text-transform: capitalize;
}

h4 {
  font-size: 20px;
  text-transform: capitalize;
  display: inline-block;
}

.floor-room-name span {
  @include breakpoint('xs-only') {
    font-size: 14px;
    line-height: 1.2;
  }
}

.name {
  display: inline-block;

  @include breakpoint('sm-and-down') {
    display: block;
    margin-bottom: 0;
  }

  &.floor {
    font-weight: 700;

    @include breakpoint('sm-and-down') {
      font-weight: 500;
    }
  }

  &.room {
    @include breakpoint('sm-and-down') {
      font-weight: 700;
      margin-top: -6px;
      margin-bottom: 3px;
    }
  }
}

.slide-fade-up-enter-active,
.slide-fade-up-leave-active {
  transition: all 0.3s ease-out;
}

.slide-fade-up-enter {
  transform: translateY(20px);
  opacity: 0;
}

.slide-fade-up-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

svg.hand {
  width: 18px;
  height: 10px;
  fill: $c-white;

  &.isBlack {
    fill: $c-black;
  }
}
</style>
